import styled from 'styled-components'

export const Wrapper = styled.div<{ $backgroundColor: string; $color: string; $borderColor: string }>`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 12px;
  width: 100%;
  padding: 12px 20px;
  border-radius: 4px;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  border: 1px solid ${({ $borderColor }) => $borderColor};
  box-sizing: border-box;
  color: var(--${({ $color }) => $color});
  text-wrap: pretty;

  svg {
    color: var(--${({ $color }) => $color});
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }
  span {
    display: block;
    line-height: 1.4;
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`
